<template>
  <div data-cy="card_contas_bancarias_container">
    <v-card
      v-for="(item, index) in listaContasBancarias"
      :key="item.card_id"
      :data-cy="`card_contas_bancarias_${index}`"
      class="mt-6 mt-md-8 py-4"
    >
      <v-card-title
        class="body-2 py-0 pr-10 mb-md-1 pl-5 text-truncate d-block primary--text text-uppercase"
        :class="$vuetify.breakpoint.mdAndUp ? 'perfil-card-apelido' : ''"
      >
        <strong>{{ item.bank_name }}</strong>
      </v-card-title>
      <v-menu
        bottom
        right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            class="mais-opcoes"
            data-cy="btn_mais_acoes"
            v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-show="!item.is_main"
            data-cy="btn_tornar_principal"
            @click="tornarPrincipal(index, item.id)"
          >
            <v-list-item-title>Tornar principal</v-list-item-title>
          </v-list-item>
          <v-list-item
            data-cy="btn_excluir_conta_bancaria"
            @click="excluirCard(item.id, item.account_number, item.bank_name)"
          >
            <v-list-item-title>Excluir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-card-text class="pt-3 pb-0 pl-5">
        <p class="mb-0">
          Favorecido:
          {{ item.full_name }}
        </p>
        <p
          class="mb-0"
        >
          {{ labelCpfCnpj(item.federal_tax_number) }}
          <TheMask
            v-model="item.federal_tax_number"
            masked
            :mask="cpfCnpjMask"
            :tokens="cpfCnpjTokens"
            class="d-none"
          />
          {{ item.federal_tax_number }}
        </p>
        <p
          class="mb-0"
        >
          Conta:
          {{ contaCorrente(item.account_number, item.account_number_suffix) }}
        </p>
        <p
          class="mb-0"
        >
          Tipo de Conta:
          {{ tipoConta(item. account_type) }}
        </p>
        <v-chip
          v-if="item.is_main"
          :class="$vuetify.breakpoint.mdAndUp ? 'perfil-tag-principal' : ''"
          label
          outlined
          color="primary--text mt-1"
        >
          Principal
        </v-chip>
      </v-card-text>
    </v-card>
    <ModalConfirmacao
      :show-dialog="abrirModalConfirmacao"
      @changeDialog="retornoModalConfirmacao($event)"
    >
      <template slot="titulo">
        Excluir conta bancária
      </template>
      <template slot="texto">
        Deseja excluir a conta {{ numeroConta }} do banco {{ nomeBanco }}?
      </template>
      <template slot="btFalse">
        Não
      </template>
      <template slot="btTrue">
        Sim
      </template>
    </ModalConfirmacao>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';

import { cpfCnpjMask, cpfCnpjTokens } from '@/utils/cpfCnpj';
import ModalConfirmacao from '@/components/MeuPerfil/ModalConfirmacao.vue';

export default {
  name: 'ListaContasBancarias',

  components: {
    ModalConfirmacao,
    TheMask,
  },

  props: {
    listaContasBancarias: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      cpfCnpjMask,
      cpfCnpjTokens,
      abrirModalConfirmacao: false,
      idContaBancaria: '',
      numeroConta: '',
      nomeBanco: '',
    };
  },

  methods: {
    tipoConta(value) {
      return value === '1' ? 'Corrente' : 'Poupança';
    },

    labelCpfCnpj(value) {
      const numero = value.replace(/[.\-/]/g, '');
      return numero.length === 11 ? 'CPF:' : 'CNPJ:';
    },

    contaCorrente(conta, digito) {
      if (digito === '') return conta;

      return `${conta}-${digito}`;
    },

    excluirCard(id, numero, nome) {
      this.abrirModalConfirmacao = true;
      this.numeroConta = numero;
      this.nomeBanco = nome;
      this.idContaBancaria = id;
    },

    retornoModalConfirmacao(value) {
      if (value) {
        this.$emit('excluirCard', this.idContaBancaria);
      }
      this.abrirModalConfirmacao = false;
    },

    tornarPrincipal(index, id) {
      this.$emit('setPrincipal', index, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.mais-opcoes {
  position: absolute;
  right: 5px;
  top: 10px;
}
.perfil-tag-principal {
  position: absolute;
  right: 56px;
  top: 15px
}
.perfil-card-apelido {
  padding-right: 150px !important;
}
</style>
